export {default as UserList} from './UserList';
export {default as Dashboard} from './Dashboard';
export {default as RedirectComp } from './RedirectComp';
export {default as NotFoundPage} from './404';

export {default as Settings} from './Settings';
export {default as Admins} from './Admins';
export {default as AdminDetail} from './AdminDetail';

export {default as Users} from './Users';
export {default as UsersDetail} from './UsersDetail';

export {default as QuestionSet} from './QuestionSet';
export {default as QuestionSetDetail} from './QuestionSetDetail';

export {default as Streams} from './Streams';
export {default as StreamsDetail} from './StreamsDetail';
export {default as StreamCodes} from './StreamCodes';
export {default as StreamCodeDetail} from './StreamCodeDetail';
export {default as StreamControl} from './StreamControl';

export {default as Results} from './Results';
export {default as ResultDetail} from './ResultDetail';

export {default as Notifications} from './Notifications';
export {default as NotificationDetail} from './NotificationDetail';











